export enum OwnershipTransferPrivateBuyerStep {
  Loading = 'Loading',
  SelectPackage = 'SelectPackage',
  SelectBan = 'SelectBan',
  CustomerData = 'CustomerData',
  CustomerAddress = 'CustomerAddress',
  PaymentData = 'PaymentData',
  GeneralMessage = 'GeneralMessage',
}
export enum ServiceType {
  Cellular = 'Cellular',
  StationaryLine = 'StationaryLine',
}
export enum ScopeName {
  TransferCli = 'TransferCli',
  TransferServices = 'TransferServices',
}

export enum PopupEnum {
  ServiceFormPopup = 'ServiceFormPopup',
  MessagePopup = 'MessagePopup',
}

const brandNameHe = () => window.Config?.brand_Name_HE;
export const MessageContent = {
  GeneralError: {
    icon: require('../Icons/error.svg'),
    title: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    secondTitle: 'באפשרותך לנסות שוב או לפנות לשירות לקוחות',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'generalError',
  },
  WorkOrder: {
    icon: require('../Icons/error.svg'),
    title: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    secondTitle: 'נציג יחזור אליך בהקדם לסיים את התהליך',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
  },
  SuccessPageCellular: {
    icon: require('../Icons/success.svg'),
    title: 'העברת בעלות למנוי מספר {transferSubscriberNumber} הושלמה בהצלחה!',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'successPageCellular',
  },

  SuccessPageStationary: {
    icon: require('../Icons/success.svg'),
    title: 'העברת בעלות על {transferProductName} הושלמה בהצלחה!',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'successPageStationary',
  },
  SuccessPageTv: {
    icon: require('../Icons/success.svg'),
    title: 'העברת בעלות על {transferProductName} הושלמה בהצלחה!',
    get secondTitle() {
      return `שם משתמש וסיסמא לשימוש בשירות ${brandNameHe()} TV יישלחו ב-SMS`;
    },
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    report: 'successPageTv',
  },
  CellularAdditionalOwnersError: {
    icon: require('../Icons/error.svg'),
    title: 'לקו מספר {transferSubscriberNumber}  יש יותר מבעלים אחד, לכן לא ניתן לבצע העברת בעלות באתר',
    secondButtonText: 'לאזור האישי',
    secondButtonClick: 'privateLobby',
    // report: 'inProgress',
  },
  AdditionalOwnersError: {
    icon: require('../Icons/error.svg'),
    title: 'לשירות חבילת {transferProductName} יש יותר מבעלים אחד, לכן לא ניתן לבצע העברת בעלות באתר',
    secondButtonText: 'לאזור האישי',
    secondButtonClick: 'privateLobby',
    // report: 'inProgress',
  },
  MustVisitServiceCenterCellular: {
    icon: require('../Icons/error.svg'),
    title:
      'לטובת ביצוע העברת בעלות על קו {transferSubscriberNumber} ל{buyerPersonalData.firstName} {buyerPersonalData.lastName} , יש להגיע לאחד ממרכזי השירות',
  },
  MustVisitServiceCenter: {
    icon: require('../Icons/error.svg'),
    title:
      'לטובת ביצוע העברת בעלות על שירות {transferProductName} ל{buyerPersonalData.firstName} {buyerPersonalData.lastName}, יש להגיע לאחד ממרכזי השירות',
  },
};

export const PopupMessageContent = {
  OpenWorkOrder: {
    title: 'לשירות {transferProductName} קיים תהליך שירות בטיפול',
    secondTitle: 'לא ניתן להשלים העברת בעלות למנוי עם תהליך שירות בטיפול',
    secondButtonText: 'הבנתי, תודה',
    secondButtonClick: 'closePopup',
    report: 'openWorkOrder',
  },
  CellularOpenWorkOrder: {
    title: 'למנוי {transferSubscriberNumber} קיים תהליך שירות בטיפול',
    secondTitle: 'לא ניתן להשלים העברת בעלות למנוי עם תהליך שירות בטיפול',
    secondButtonText: 'הבנתי, תודה',
    secondButtonClick: 'closePopup',
    report: 'openWorkOrder',
  },
  TransferGeneralError: {
    title: 'לא ניתן לבצע העברת בעלות באתר לשירות {transferProductName}',
    secondButtonText: 'הבנתי, תודה',
    secondButtonClick: 'closePopup',
    report: 'transferGeneralError',
  },
  CellularGeneralTransferError: {
    title: 'לא ניתן לבצע העברת בעלות באתר למנוי {transferSubscriberNumber}',
    secondButtonText: 'הבנתי, תודה',
    secondButtonClick: 'closePopup',
    report: 'transferGeneralError',
  },

  CellularNPStatusError: {
    title: 'מנוי מספר {transferSubscriberNumber}<br /> נמצא בתהליך ניוד',
    secondTitle: `לא ניתן להשלים את העברת הבעלות בזמן תהליך ניוד`,
    secondButtonText: 'הבנתי, תודה',
    secondButtonClick: 'closePopup',
    report: 'cellularNPStatusError',
  },
  CellularAbroadError: {
    title: `מנוי מספר {transferSubscriberNumber}<br /> נמצא בחו''ל`,
    secondTitle: `אפשר להשלים את העברת הבעלות באתר עם חזרת המנוי לארץ`,
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'cellularAbroadError',
  },
  CellularSubStatusError: {
    title: 'מנוי מספר {transferSubscriberNumber} מושהה',
    secondTitle: 'לא ניתן להשלים העברת בעלות למנוי מושהה',
    secondButtonText: 'הבנתי, תודה',
    secondButtonClick: 'closePopup',
    report: 'cellularSubStatusError',
  },
  CellularCellcomDuError: {
    title: '<br />זיהינו שיש למנוי מספר {transferSubscriberNumber} שירות נוסף',
    secondTitle: 'לא ניתן להשלים העברת בעלות למנוי בעל שירות נוסף',
    secondButtonText: 'הבנתי, תודה',
    secondButtonClick: 'closePopup',
    //report: '',
  },
  CellularEsimError: {
    title: 'מנוי מספר {transferSubscriberNumber}<br /> הינו מנוי eSIM',
    secondTitle: 'בשלב זה לא ניתן להעביר בעלות למנוי eSIM',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'cellularEsimError',
  },
  CellularDataPackageError: {
    title: 'מנוי מספר {transferSubscriberNumber}<br /> הינו מנוי דאטה',
    secondTitle: 'בשלב זה לא ניתן להעביר בעלות למנוי דאטה',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'closePopup',
    report: 'cellularDataPackageError',
  },
  SimResponsibilities: {
    title: 'העברת כרטיס SIM',
    secondTitle: 'שימו לב, באחריותכם להעביר את כרטיס ה-SIM מהבעלים הקודמים לבעלים החדשים',
    buttonText: 'הבנתי, תודה',
    buttonClick: 'setSimResponsibilities',
  },
};

export const CollapseLabelCheckBox = {
  stationary: {
    get defaultText() {
      return `אני מאשר/ת את בקשתו של המוכר/ת לבצע העברת בעלות אלי בשירות אינטרנט ו/או ${brandNameHe()} TV, בציוד קצה ובתכנית החיוב ...`;
    },
    get extendedText() {
      return `אני מאשר/ת את בקשתו של המוכר/ת לבצע העברת בעלות אלי בשירות אינטרנט ו/או ${brandNameHe()} TV, בציוד קצה ובתכנית החיוב ואני מסכים/ה לבקשה ולתנאים שלה. קראתי את הסכם מנוי – תנאים כלליים של ${brandNameHe()} תקשורת קווית ש.מ. ואת הסכם התכנית אליה אצטרף ואני מסכים/ה לתנאים המופיעים בהם. ידוע לי כי השירותים עוברים לבעלותי כמו שהם, לרבות שירותים או ערוצים שנוספו על ידי המוכר.`;
    },
  },
  cellular: {
    defaultText: 'אני מאשר/ת את בקשתו של המוכר לבצע העברות בעלות אלי ...',
    get extendedText() {
      return `אני מאשר/ת את בקשתו של המוכר לבצע העברות בעלות אלי ואני מסכים/ה לבקשה ולתנאים שלה. קראתי את התנאים הכלליים להצטרפות לרשת ${brandNameHe()} ואת הסכם התכנית אליה אצטרף ואני מסכים/ה לתנאים המופיעים בהם. `;
    },
  },
};
